// checks a Resource and returns the Resource.contained value as a dictionary with id as key and index and json values
const getContainedResources = (fhirJson) => {
    let containedResources = {};
    for (let containedIndex in fhirJson.contained) {
        let containedResource = fhirJson.contained[containedIndex];
        if (containedResource.id) {
            containedResources[containedResource.id] = {
                "index": containedIndex,
                "json": containedResource
            }
        }
    }
    return containedResources;
}

export default getContainedResources;